import { StandardEvents } from '@shopify/events';

/**
 * Swaps itself for the freshly rendered copy when the shopper picks another variant,
 * so blocks inside it can depend on the selected variant. Mirrors media-gallery.js.
 */
class CustomVariantContent extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector(`custom-variant-content[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.replaceWith(fresh);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[custom-variant-content]', error);
      });
  };
}

if (!customElements.get('custom-variant-content')) {
  customElements.define('custom-variant-content', CustomVariantContent);
}
